import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import { Modal } from 'react-bootstrap';
import Select from 'react-select';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class ScheduleRequestsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      schedule_request: {},
      change_status: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.openModal = this.openModal.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.confirmChangeStatus = this.confirmChangeStatus.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var id = null;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/solicitacoes';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({data: responseJson.data.main, list_staffs: responseJson.data.list_staffs});
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn button-inline btn-sm btn-primary" value={cell} onClick={() => { this.openModal(cell) }}>
          <i className="fa fa-fw fa-tasks"></i>
        </button>
        {(row.status == 'opened' || row.status == 'additional_approval_acceptance_pending' || row.status == 'additional_info_acceptance_pending' || row.status == 'additional_info_pending' || row.status == 'additional_approval_pending') ?
          <button className="btn button-inline btn-sm btn-success" onClick={() => { this.changeStatus(cell, 'approved') }}>
            <i className="fa fa-check"></i>
          </button>
        
        : ''
        }
        {(row.status == 'opened' || row.status == 'additional_approval_acceptance_pending' || row.status == 'additional_info_acceptance_pending' || row.status == 'additional_info_pending' || row.status == 'additional_approval_pending') ?
          <button className="btn button-inline btn-sm btn-danger" onClick={() => { this.changeStatus(cell, 'reproved') }}>
            <i className="fa fa-times-circle"></i>
          </button>
        : ''
        }
        {(row.status == 'opened' || row.status == 'additional_approval_acceptance_pending' || row.status == 'additional_info_acceptance_pending') ?
          <button className="btn button-inline btn-sm btn-warning" onClick={() => { this.changeStatus(cell, 'additional_info_pending') }}>
            <i className="fa fa-question-circle"></i>
          </button>
        : ''
        }
        {(row.status == 'opened' || row.status == 'additional_approval_acceptance_pending' || row.status == 'additional_info_acceptance_pending') ?
          <button className="btn button-inline btn-sm btn-warning" onClick={() => { this.changeStatus(cell, 'additional_approval_pending') }}>
            <i className="fa fa-pencil-square-o"></i>
          </button>
        : ''
        }
      </div>
    );

    return botao;
  }

  openModal (schedule_request_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/solicitacao/' + schedule_request_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({schedule_request: responseJson.data, modal: true});
        self.handleAlert('', '', 'closed');
      });
    });
  }

  changeStatus (schedule_request_id, change_status, additional_info_request, additional_info_answer, staff_id) {
    if(change_status == 'approved') {
      this.confirmChangeStatus('approved', schedule_request_id);
    } else {
      this.setState({additional_info_modal: true, staff_id: staff_id, change_status: change_status, fixed_additional_info_request: additional_info_request, additional_info_answer: additional_info_answer, schedule_request_id: schedule_request_id});
    }
  }
  
  confirmChangeStatus (change_status, schedule_request_id) {
    if(window.confirm('Tem certeza de que deseja mudar o status desta solicitação?')) {
      var datasave = {
        type: 'administrativo',
        schedule_request_id: schedule_request_id,
        staff_id: this.state.staff_id,
        additional_info_request: this.state.additional_info_request,
        additional_info_answer: this.state.additional_info_answer,
        reproval_justification: this.state.reproval_justification,
        change_status: change_status,
      };
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/solicitacao/status', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({data: responseJson.data, schedule_request_id: null, change_status: null, additional_info_modal: false, additional_info_request: null, additional_info_answer: null, reproval_justification: null, staff_id: null});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
  
    }
  }

  exportMedicalCertificate (url) {
    window.open(config.get('cdn') + '/files/atestados/' + url);
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title">Lista de Solicitações</h3>
      <hr/>
        <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há solicitações cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
        
            <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='50'>ID</TableHeaderColumn>
            <TableHeaderColumn dataField="user" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Solicitante</TableHeaderColumn>
            <TableHeaderColumn dataField="schedule" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Escala</TableHeaderColumn>
            <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>Colaborador</TableHeaderColumn>
            <TableHeaderColumn dataField="change_type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Tipo de solicitação</TableHeaderColumn>
            <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='250'>Justificativa</TableHeaderColumn>
            <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Status</TableHeaderColumn>
            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Ações</TableHeaderColumn>

        </BootstrapTable>

        {/* Modal de detalhamento da solicitação */}
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Visualização de requisição</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>

            <div className="row">
                <div className="col-md-6 form-group">
                    <label>Escalas do mês atual</label>
                    <input type="text" name="schedule" className="form-control" disabled value={this.state.schedule_request.schedule} />
                </div>
                <div className="col-md-6 form-group">
                    <label>Colaborador</label>
                    <input type="text" name="staff" className="form-control" disabled value={this.state.schedule_request.staff} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 form-group">
                    <label>Tipo de alteração</label>
                    <input type="text" name="change_type_str" className="form-control" disabled value={this.state.schedule_request.change_type_str} />
                </div>
                <div className="col-md-6 form-group">
                    <label>Solicitante</label>
                    <input type="text" name="user" className="form-control" disabled value={this.state.schedule_request.user} />
                </div>
            </div>
            {this.state.schedule_request.change_type == 'change_group' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>Grupo Atual</label>
                            <input type="text" name="current_schedule_group" className="form-control" disabled value={this.state.schedule_request.current_group} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>Novo grupo</label>
                            <input type="text" name="new_schedule_group" className="form-control" disabled value={this.state.schedule_request.new_group} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                            <label>Data de início:</label>
                            <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>A alteração é definitiva?</label>
                                <br/>
                                <input type="text" name="definitive_change_str" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                            </div>
                        </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Data de término:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_regime' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>Quinzena Atual</label>
                            <input type="text" name="current_regime" className="form-control" disabled value={this.state.schedule_request.current_regime} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>Nova quinzena</label>
                            <input type="text" name="new_regime" className="form-control" disabled value={this.state.schedule_request.new_regime} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Data de início:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_base' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>Base Atual</label>
                            <input type="text" name="current_base" className="form-control" disabled value={this.state.schedule_request.current_base} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>Nova base</label>
                            <input type="text" name="new_base" className="form-control" disabled value={this.state.schedule_request.new_base} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Data de início:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>A alteração é definitiva?</label>
                                <br/>
                                <input type="text" name="definitive_change_str" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                            </div>
                        </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Data de término:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                    
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_period' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>Período Atual</label>
                            <input type="text" name="current_schedule_period" className="form-control" disabled value={this.state.schedule_request.current_schedule_period} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>Nova período</label>
                            <input type="text" name="new_schedule_period" className="form-control" disabled value={this.state.schedule_request.new_schedule_period} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Data de início:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }

            {this.state.schedule_request.change_type == 'change_role' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>Função Atual</label>
                            <input type="text" name="current_role" className="form-control" disabled value={this.state.schedule_request.current_role} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>Nova função</label>
                            <input type="text" name="new_role" className="form-control" disabled value={this.state.schedule_request.new_role} />
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Data de início:</label>
                            <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>A alteração é definitiva?</label>
                            <br/>
                            <input type="text" name="definitive_change_str" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                        </div>
                    </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Data de término:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>N° do chamado:</label>
                                    <input type="text" name="request_number" className="form-control" disabled value={this.state.schedule_request.request_number} />
                                </div>
                            </div>
                        </div>
                        : 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>N° da MP aprovada:</label>
                                    <input type="text" name="mp_number" className="form-control" disabled value={this.state.schedule_request.mp_number} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_absences' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Data de início:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Tempo indeterminado?</label>
                                <br/>
                                <input type="text" name="schedule" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                            </div>
                        </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Data de término:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Atestado:</label>
                                    <br></br>
                                    <button onClick={() => this.exportMedicalCertificate(this.state.schedule_request.file)} className="btn btn-primary" value={this.state.schedule_request.id}>
                                      <i className="fa fa-fw fa-file-pdf-o"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Atestado:</label>
                                    <br></br>
                                    <button onClick={() => this.exportMedicalCertificate(this.state.schedule_request.file)} className="btn btn-primary" value={this.state.schedule_request.id}>
                                      <i className="fa fa-fw fa-file-pdf-o"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'other_changes' ? 
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Descrição:</label>
                                <textarea value={this.state.schedule_request.description} name="description" className="form-control" placeholder="" disabled style={{height: '200px'}} required />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }
                    
            {this.state.schedule_request.change_type !== null && this.state.schedule_request.change_type !== 'change_absences' ? 
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Justificativa:</label>
                                <textarea value={this.state.schedule_request.reason} disabled name="reason" className="form-control" placeholder="" style={{height: '200px'}} required />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }


          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>

        {/* Modal de solicitação de informação/aprovação adicional */}
        <Modal show={this.state.additional_info_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">
              {
                (this.state.change_status == 'additional_approval_pending' || this.state.change_status == 'additional_approval_acceptance_pending') ?
                'Aprovação adicional'
                : (this.state.change_status == 'additional_info_pending' || this.state.change_status == 'additional_info_acceptance_pending') ?
                'Informações adicionais'
                : (this.state.change_status == 'reproved') ? 'Reprovação' : 'Detalhes'
              }
            </h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ schedule_request_id: null, change_status: null, additional_info_modal: false, additional_info_request: null, additional_info_answer: null, reproval_justification: null, staff_id: null })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            {this.state.change_status == 'additional_approval_pending' ?
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Colaborador</label>
                  <Select
                  className=""
                  name="staff_id"
                  value={this.state.staff_id}
                  placeholder={'Selecione um colaborador'}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.list_staffs}
                  required
                  />
                </div>
              </div>
              : ''
            }

            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                    <label>{this.state.change_status == 'reproved' ? 'Justificativa:' : 'Exigência:'}</label>
                    {(this.state.change_status == 'additional_info_acceptance_pending' || this.state.change_status == 'additional_approval_acceptance_pending') ?
                      <textarea value={this.state.fixed_additional_info_request} name="fixed_additional_info_request" className="form-control" onChange={this.handleChange.bind(this, 'fixed_additional_info_request')} placeholder="" style={{height: '200px'}} disabled />
                    : (this.state.change_status == 'additional_info_pending' || this.state.change_status == 'additional_approval_pending') ?
                      <textarea value={this.state.additional_info_request} name="additional_info_request" className="form-control" onChange={this.handleChange.bind(this, 'additional_info_request')} placeholder="" style={{height: '200px'}} required />
                    : (this.state.change_status == 'reproved') ?
                      <textarea value={this.state.reproval_justification} name="reproval_justification" className="form-control" onChange={this.handleChange.bind(this, 'reproval_justification')} placeholder="" style={{height: '200px'}} required />
                    : ''
                    }
                </div>
              </div>
            </div>
            {(this.state.change_status == 'additional_info_acceptance_pending' || this.state.change_status == 'additional_approval_acceptance_pending') ?
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Resposta:</label>
                    <textarea value={this.state.additional_info_answer} name="additional_info_answer" className="form-control" onChange={this.handleChange.bind(this, 'additional_info_answer')} placeholder="" style={{height: '200px'}} required />
                  </div>
                </div>
              </div>
              : ''
            }
            <div className="row">
                <div className="col-md-12">
                  {this.state.change_status == 'reproved' ?
                    <button className="btn btn-lg btn-block btn-danger" onClick={() => { this.confirmChangeStatus(this.state.change_status, this.state.schedule_request_id) }}>
                      <i className="fa fa-fw fa-save"></i> Reprovar
                    </button>
                    : ''
                  }
                  {this.state.change_status == 'additional_info_pending' ?
                    <button className="btn btn-lg btn-block btn-primary" onClick={() => { this.confirmChangeStatus(this.state.change_status, this.state.schedule_request_id) }} >
                      <i className="fa fa-fw fa-save"></i> Exigir informações adicionais
                    </button>
                    : ''
                  }
                  {this.state.change_status == 'additional_approval_pending' ?
                    <button className="btn btn-lg btn-block btn-primary" onClick={() => { this.confirmChangeStatus(this.state.change_status, this.state.schedule_request_id) }} >
                      <i className="fa fa-fw fa-save"></i> Exigir aprovação adicional
                    </button>
                    : ''
                  }
                  {this.state.change_status == 'additional_info_acceptance_pending' ?
                    <button className="btn btn-lg btn-block btn-primary" onClick={() => { this.confirmChangeStatus('approved', this.state.schedule_request_id) }}>
                      <i className="fa fa-fw fa-save"></i> Enviar informações
                    </button>
                    : ''
                  }
                  {this.state.change_status == 'additional_approval_acceptance_pending' ?
                    <button className="btn btn-lg btn-block btn-success" onClick={() => { this.confirmChangeStatus('additional_approval_approved', this.state.schedule_request_id) }}>
                      <i className="fa fa-fw fa-save"></i> Aprovar
                    </button>
                    : ''
                  }
                  {(this.state.change_status == 'additional_approval_acceptance_pending') ?
                    <button className="btn btn-lg btn-block btn-danger" onClick={() => { this.confirmChangeStatus('additional_approval_reproved', this.state.schedule_request_id) }}>
                      <i className="fa fa-fw fa-save"></i> Reprovar
                    </button>
                    : ''
                  }
                </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ schedule_request_id: null, change_status: null, additional_info_modal: false, additional_info_request: null, additional_info_answer: null, reproval_justification: null, staff_id: null })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default ScheduleRequestsIndex;



// WEBPACK FOOTER //
// ./src/Components/ScheduleRequests/ScheduleRequestsIndex.js